import JTitle from './JTitle';

export default JTitle;
